import React, {Component, useState} from 'react';
import PropTypes from 'prop-types';
import {Formik} from "formik";
import {BootstrapError, BootstrapField} from "../../../helpers/Field";
import * as yup from 'yup';
import {registerUser} from "../../../requests/UserRequests";
import {withRouter} from "react-router-dom";
import axios from "../../../axios";
import {updateState} from "../../../actions/CommonActions";
import * as types from "../../../constants/ActionTypes";
import {connect} from "react-redux";
import {toast} from "react-toastify";

const schema = yup.object().shape({
  email: yup.string().email().required("Email is required."),
  firstName: yup.string().required("First Name Required."),
  lastName: yup.string().required("Last Name Required."),
  company: yup.string().required("Company Required."),
  password: yup.string().required("Password is required.").min(8, "Password must be at least 8 characters long."),
  verifyPassword: yup.string().oneOf([yup.ref("password"), null], "Passwords must match.").required("Passwords must match."),
});


function RegistrationRequestForm(props) {
  let [errorMessage, setErrorMessage] = useState(null);
  return (
    <div>
      <Formik
        validationSchema={schema}
        onSubmit={(formProps, bag) => {
            registerUser(formProps).then((response) => {
            sessionStorage.setItem('token', response.token);
            sessionStorage.setItem('refreshToken', response.refreshToken);
            axios.instance.defaults.headers.common['Authorization'] = `Bearer ${response.token}`;
            updateState(props.dispatch, types.SET_IS_LOGGED_IN, true);
            
            if (response.user.isConfirmed) {
              props.history.push("/invoices"); 
            } else {
              props.history.push("/auto-register/confirm-instructions")
            }
            }).catch(error => {
                setErrorMessage(error.response.data.Message);
                toast.error(error.response.data.Message, { position: toast.POSITION.TOP_RIGHT });
          });
        }}
        render={props =>
          <div className="card">
            <form onSubmit={props.handleSubmit}>
              <div className="row">
                <div className={"col-12"}>
                  {errorMessage && <p className={"text-danger"}>{errorMessage}</p>}
                  <div className="form-group">
                    <label>Email</label>
                    <BootstrapField type={"email"} name={"email"}/>
                    <BootstrapError name={"email"}/>
                  </div>
                  <div className="form-group">
                    <label>First Name</label>
                    <BootstrapField type={"text"} name={"firstName"}/>
                    <BootstrapError name={"firstName"}/>
                  </div>
                  <div className="form-group">
                    <label>Last Name</label>
                    <BootstrapField type={"text"} name={"lastName"}/>
                    <BootstrapError name={"lastName"}/>
                  </div>
                  <div className="form-group">
                    <label>Company</label>
                    <BootstrapField type={"text"} name={"company"}/>
                    <BootstrapError name={"company"}/>
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <BootstrapField type={"password"} name={"password"}/>
                    <BootstrapError name={"password"}/>
                  </div>
                  <div className="form-group">
                    <label>Verify Password</label>
                    <BootstrapField type={"password"} name={"verifyPassword"}/>
                    <BootstrapError name={"verifyPassword"}/>
                  </div>
                  <div className={"form-group"}>
                    <button type={"submit"} className={"btn btn-primary"}>Next</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        }/>
    </div>
  );
}

RegistrationRequestForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default withRouter(connect()(RegistrationRequestForm));
